import { BaseSortPlainObject } from './baseSort.plainObject';

export class SortPlainObject extends BaseSortPlainObject {
}
